// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoSelect from "../../../components/Inputs/GoSelect";
import GoDrawer from "../../../components/Inputs/GoDrawer";
// Services
import { get, put, gen_link } from "../../../services/FetchHelper";
// Utils
import Config from "./Config";
// Hooks
import usePermissions from "../../../hooks/usePermissions";

const CsvUpload = () => {
    const permission = usePermissions();
    const [config, setConfig] = useState(Config[0]);

    const handleChange = (event) => {
        setConfig(event.target.value);
    };

    const downloadCSV = () => {
        const link = document.createElement('a');
        link.href = gen_link(config.entityApi);
        link.target = '_blank';
        link.click();
    };

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h6"
                        component="div"
                        sx={{ flexGrow: 1 }}>
                        {config.title}
                    </Typography>
                    <GoSelect
                        title="Select Master"
                        name="master"
                        value={config}
                        items={Config}
                        displayKey="componentName"
                        itemValue="fullItem"
                        handleChange={(e) => handleChange(e)}
                        size="small"
                    />
                    {permission.has(config.downloadPermission) &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="typcn:download" />}
                            onClick={downloadCSV}
                        >
                            Download
                        </Button>}
                </Stack>
                {config.component}
            </Container>
        </React.Fragment>
    )
}

export default CsvUpload;